import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      variant: 'flex.row.start.center',
      flexWrap: 'wrap',
      gap: [6, 11],
      mb: 11,
    };

    this.iconsRow = {
      variant: 'flex.row.start.center',
    };

    this.icon = {
      width: '20px',
      height: '20px',
      objectFit: 'contain',
      mr: [4, 3],
    };

    this.label = {
      variant: 'text.label.2',
      fontSize: ['14px', 1],
      maxWidth: '175px',
      mt: '1px',
    };
  })()
);
